<div class="dialog-wrap">
  <h3>{{ "TRAINING_INTRO_DIALOG.TITLE" | translate }}</h3>
  <p>{{ "TRAINING_INTRO_DIALOG.TEXT" | translate }}</p>
  <div class="phase-row">
    <p class="phase-label">{{ currentPhase.labelKey | translate }}</p>
    <button type="button" class="pause-toggle" (click)="togglePause()" [attr.aria-label]="(isPaused ? 'TRAINING_INTRO_DIALOG.RESUME_DEMO' : 'TRAINING_INTRO_DIALOG.PAUSE_DEMO') | translate">
      <span class="material-symbols-outlined">{{ isPaused ? 'resume' : 'pause' }}</span>
    </button>
  </div>
  <div class="preview">
    <div class="chart-container">
      <canvas id="introBarChart" #introBarChart></canvas>
    </div>
    <div class="video-container" [class.video-paused]="videoStopped">
      <video #introVideo class="preview-video" src="assets/videos/brain-activity.mp4" loop muted playsinline></video>
      <span class="video-badge" [class.video-badge-paused]="videoStopped">{{ videoBadgeKey | translate }}</span>
      <span class="direction-badge">{{ directionBadgeKey | translate }}</span>
    </div>
  </div>
  <div class="oscilloscope-preview">
    <div class="oscilloscope-container">
      <canvas id="introOscilloscopeChart" #introOscilloscopeChart></canvas>
    </div>
    <p class="threshold-explain">{{ "TRAINING_INTRO_DIALOG.THRESHOLD_EXPLAIN" | translate }}</p>
  </div>
  <div class="dialog-actions">
    <button mat-button (click)="cancel()">{{ "TRAINING_INTRO_DIALOG.CANCEL" | translate }}</button>
    <button mat-raised-button color="primary" (click)="close()">{{ "TRAINING_INTRO_DIALOG.BUTTON" | translate }}</button>
  </div>
</div>
